import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import apiCall from '../../apiCall';
import { customHeaders, indianProjectsBaseURL } from './../../../../Containers/Config/index';

import { SEND_APPROVAL_MAIL, SEND_APPROVAL_MAIL_SUCCESS, SEND_APPROVAL_MAIL_ERROR } from './../../actionType';
import { Constant } from '../../../../Containers/Helpers/constant';
import cogoToast from 'cogo-toast';

function* sendApprovalMail({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/admin/send-mail`,
      method: 'POST',
      headers: { Authorization: Constant?.CLIENT_TOKEN, ...customHeaders, 'Project-Code': 'ADMIN_ACCESS' },
      params: {
        ...payload?.urlParam,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({ type: SEND_APPROVAL_MAIL_SUCCESS, payload: response });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({ type: SEND_APPROVAL_MAIL_ERROR, payload: response.error });
    }
  } catch (error) {
    yield put({ type: SEND_APPROVAL_MAIL_ERROR, payload: error });
  }
}

export function* watchSendApprovalMail() {
  yield takeEvery(SEND_APPROVAL_MAIL, sendApprovalMail);
}

function* sendApprovalMailSaga() {
  yield all([fork(watchSendApprovalMail)]);
}

export default sendApprovalMailSaga;
